<script setup lang="ts">
import { computed } from "vue";

const props = defineProps<{ text: string; highlight: string }>();
const segmenter = new Intl.Segmenter("vi", { granularity: "grapheme" });
const fold = (text: string) => text.normalize("NFC").toLocaleLowerCase("vi").normalize("NFC");

const parts = computed(() => {
  const needle = fold(props.highlight);
  if (!needle) return [{ text: props.text, marked: false }];

  let searchable = "";
  const boundaries = new Map<number, number>([[0, 0]]);
  for (const { segment, index } of segmenter.segment(props.text)) {
    searchable += fold(segment);
    boundaries.set(searchable.length, index + segment.length);
  }

  const result: { text: string; marked: boolean }[] = [];
  let cursor = 0;
  let offset = 0;
  while (offset < searchable.length) {
    const match = searchable.indexOf(needle, offset);
    if (match === -1) break;
    const start = boundaries.get(match);
    const end = boundaries.get(match + needle.length);
    if (start === undefined || end === undefined) {
      offset = match + 1;
      continue;
    }
    if (start > cursor) result.push({ text: props.text.slice(cursor, start), marked: false });
    result.push({ text: props.text.slice(start, end), marked: true });
    cursor = end;
    offset = match + needle.length;
  }
  if (cursor < props.text.length) result.push({ text: props.text.slice(cursor), marked: false });
  return result;
});
</script>

<template>
  <template v-for="(part, index) in parts" :key="index"><mark v-if="part.marked" class="bg-yellow-200 text-black">{{ part.text }}</mark><template v-else>{{ part.text }}</template></template>
</template>
